// Two filter layers. Status is server-rendered: the select submits a GET form into the
// explore-activities Turbo frame, so Rails decides which tiles exist and in what order.
// Type chips are the real-time exception in docs/conventions/server-rendered-dom.md and
// only hide or show tiles already in that list.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "status", "chip", "tile", "empty"]

  connect() {
    const activeTab = this.tabTargets.find((tab) => tab.classList.contains("explore-tab--active")) || this.tabTargets[0]
    if (activeTab) this.showTab(activeTab.dataset.tab)

    const activeChip = this.chipTargets.find((chip) => chip.classList.contains("explore-chip--active"))
    this.applyType(activeChip ? activeChip.dataset.type : "all")
  }

  switchTab(event) {
    const name = event.currentTarget.dataset.tab
    this.showTab(name)
    this.syncUrl(name)
  }

  syncUrl(name) {
    const url = new URL(window.location.href)
    if (url.searchParams.get("tab") === name) return

    name === "activities" ? url.searchParams.delete("tab") : url.searchParams.set("tab", name)
    window.history.replaceState(window.history.state, "", url)
  }

  filterType(event) {
    this.restoreStatusFocus = false
    this.applyType(event.currentTarget.dataset.type)
  }

  submitStatus(event) {
    this.restoreStatusFocus = document.activeElement === event.currentTarget
    this.applyType("all")
    event.currentTarget.form.requestSubmit()
  }

  statusLoaded() {
    this.applyType(this.selectedType || "all")
    if (this.restoreStatusFocus && this.hasStatusTarget) this.statusTarget.focus()
    this.restoreStatusFocus = false
  }

  // catalog-refresh swaps the tile list in place; keep the member's type chip applied to it.
  keepTypeOnRefresh(event) {
    if (event.target.getAttribute("target") !== "explore-tiles") return

    const render = event.detail.render
    event.detail.render = async (streamElement) => {
      await render(streamElement)
      this.applyType(this.selectedType || "all")
    }
  }

  showTab(name) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === name
      tab.classList.toggle("explore-tab--active", active)
      tab.setAttribute("aria-selected", active)
    })
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name
    })
  }

  applyType(type) {
    this.selectedType = type
    this.chipTargets.forEach((chip) => {
      const active = chip.dataset.type === type
      chip.classList.toggle("explore-chip--active", active)
      chip.setAttribute("aria-pressed", active)
    })
    let visibleCount = 0
    this.tileTargets.forEach((tile) => {
      const hidden = type !== "all" && tile.dataset.exploreType !== type
      tile.hidden = hidden
      if (!hidden) visibleCount += 1
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleCount > 0
  }
}
